import { routerMiddleware } from "connected-react-router";

export default routerMiddleware;
